export default theme => ({
  container: {
    padding: theme.spacing(2),
  },
  sectionTitle: {
    marginBottom: '1em',
    color: theme.palette.primary.main,
  },
  filtersContainer: {
    marginBottom: '1em',
    width: '100%',
  },
  rowDecu: {
    backgroundColor: '#e0e0e0',
    opacity: 0.7,
    textDecoration: 'line-through',
  },
  mailtoLink: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  checkboxCell: {
    textAlign: 'center',
  },
  sanitaireCell: {
    display: 'inline-block',
    maxWidth: '250px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'help',
  },
  currency: {
    textAlign: 'right',
  },
  editableField: {
    marginBottom: theme.spacing(2),
  },
  sectionDivider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  copainSection: {
    backgroundColor: '#f5f5f5',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
})
